import { useState } from 'react';
import WarehouseCommonApi from '../../../../../../API/warehouse/common-api';
import minus from '../../../../../../assets/media/icons/minus.svg';
import plus from '../../../../../../assets/media/icons/plus.svg';
import { Row } from '../../../../../../components/Basic/Blocks';
import { Button } from '../../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../../components/Basic/Elements';
import { Input } from '../../../../../../components/Basic/Inputs';
import { TYPE_BUTTONS } from '../../../../../../constans';
import ReasonStockDebitPopUp from '../../../DebitPopUp';

const InventoryStepper = ({ item = {}, save = () => { }, ...props }) => {
  const [value, setValue] = useState(0);

  const [showReasonDebit, setShowReasonDebit] = useState(false);

  const onChange = async (id, value, reason = '') => {
    await WarehouseCommonApi.changeProduct({
      data: {
        warehouseId: id,
        field: 'inventory_remains',
        isInventory: true,
        value: parseInt(value),
        reason,
      }
    })
      .then((r) => {
        save(r.warehouseProduct);
        setValue(0);
      })
      .catch();
  };

  const clickAdd = async () => {
    if (value > 0) {
      onChange(item.id, value);
    }
  };

  const clickDebit = async (reason) => {
    if (value > 0) {
      onChange(item.id, 0 - value, reason); // передаем отрицательное число
    }
    setShowReasonDebit(false);
  };

  const reserved = 0;

  return (
    <Row>
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginRight: '10px' }}
        disabled={item.inventory_remains - reserved < value}
        onClick={() => (value > 0 ? setShowReasonDebit(true) : {})}
      >
        <Icon src={minus} width="16px" />
      </Button>
      <Input value={value} onChange={(v) => setValue(v)} style={{ width: '25px' }} center />
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginLeft: '10px' }}
        onClick={clickAdd}
      >
        <Icon src={plus} width="15px" />
      </Button>
      {showReasonDebit && (
        <ReasonStockDebitPopUp clickOk={(reason) => clickDebit(reason)} close={() => setShowReasonDebit(false)} />
      )}
    </Row>
  );
};

export default InventoryStepper;
